import React, {Component, useState} from "react";
import '../../components_style/RegisterForm.css'

import '../../components_style/rtl_css/RegisterForm.css'
import {adminApi} from "../../services/ApiService";

import SvGraphics from "../../assets/SvGraphics";
import DatePicker from "react-datepicker";
import * as XLSX from 'xlsx';

const AdminGenerateReport = (props) => {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const closeSideBar = async () => {
        props.closeSideBar(false)
    }
    const generateReport = async () => {
        let startDateText=startDate.toISOString().split('T')[0]
        let endDateText=endDate.toISOString().split('T')[0]

        startDate.setHours(0)
        startDate.setMinutes(0)
        startDate.setSeconds(0)
        startDate.setMilliseconds(0)
        let response = await adminApi.generateLeumitReport(startDate, endDate)

        if (response && response.data) {
            let requests =response.data.requests

            const dataToExport = [
                ['RequestID', 'ID_passport','Status_desc_he','choose_programm','requestDate','updatedAt','incompleteRequest','TreatmentCategory',
                    'TreatmentIntakeMethod','TreatmentMonthlyDosage'],
            ];

            for (let i = 0; i < requests.length; i++) {
                let entryToAdd=[]
                let choose_programm =requests[i].choose_programm ==='new'?'הוצאת רישיון חדש':
                    requests[i].choose_programm ==='renew'?'חידוש רישיון למטופלים קיימים':
                        requests[i].choose_programm ==='renew2'?'חידוש רישיון למטופלים חדשים':
                            requests[i].choose_programm ==='newPrescription'?'הוצאת מרשם חדש':
                                requests[i].choose_programm ==='renewPrescription'?
                                    'חידוש מרשם למטופלים קיימים':'חידוש מרשם למטופלים חדשים'


                let idLength = requests[i].Patient?.PII?.ID_passport.length
                entryToAdd.push(requests[i].RequestID)
                entryToAdd.push(requests[i].Patient?.PII?.ID_passport.substring(idLength-3))
                entryToAdd.push(requests[i].RequestStatus?.status_desc_he)
                entryToAdd.push(choose_programm)
                entryToAdd.push(requests[i].requestDate)
                entryToAdd.push(requests[i].updatedAt)
                entryToAdd.push(!!requests[i].StatusChangeHistory || requests[i].RequestStatus?.status_ID===9)
                if(requests[i].Patient_treatments && requests[i].Patient_treatments[0]){
                    entryToAdd.push(requests[i].Patient_treatments[0].TreatmentCategory?requests[i].Patient_treatments[0].TreatmentCategory:'')
                    entryToAdd.push(requests[i].Patient_treatments[0].TreatmentIntakeMethod)
                    entryToAdd.push(requests[i].Patient_treatments[0].TreatmentMonthlyDosage)
                }

                dataToExport.push(entryToAdd)
            }

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet(dataToExport);
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});

            const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `leumitReport-${startDateText}_${endDateText}.xlsx`);
            document.body.appendChild(link);
            link.click();

        }

        props.closeSideBar(false)
    }


    let display = props.isSideBarOpen ? 'block' : 'none'
    let width = props.isSideBarOpen ? "600px" : "0px"
    let container_width = props.isSideBarOpen ? "100%" : "0px"
    const {t} = props

    return (
        <div className={"sidenav-complete"} style={{width: container_width, height: "100%"}}>
            <div className={"sidenav"} style={{width: width, height: "100%", float: 'right'}}>
                <SvGraphics onClick={closeSideBar.bind(this)} className={'close-bar-x'} svgname={'close'}
                            height={'15px'} width={'15px'} style={{
                    float: 'left',
                    top: '10px',
                    left: '10px',
                    position: 'absolute',
                    cursor: 'pointer'
                }}/>
                <div className={'register-form-title container block'}>
                    <h3 className={'h-centered block'}>{props.title}</h3>
                </div>

                <div style={{margin: '20px'}}>
                    <div className={'date-label-block'}>
                        <label className={'date-label'}> {t('hcpLeumitPatientRequests.startDate')}</label>

                        <DatePicker
                            // wrapperClassName={'date-component'}
                            showYearDropdown={true} showMonthDropdown={true}
                            dateFormat="dd/MM/yyyy"
                            selected={startDate}
                            maxDate={new Date()}
                            onChange={(event) => setStartDate(event)}/>
                    </div>

                    <div className={'date-label-block'}>
                        <label className={'date-label'}> {t('hcpLeumitPatientRequests.endDate')}</label>
                        <DatePicker
                            // wrapperClassName={'date-component'}
                            showYearDropdown={true} showMonthDropdown={true}
                            dateFormat="dd/MM/yyyy"
                            selected={endDate}
                            maxDate={new Date()}
                            onChange={(event) => setEndDate(event)}/>
                    </div>

                </div>


            </div>
            <div className={'register-form-nav-container block'}>
                <div className={'register-form-nav'}
                     style={{width: width, display: 'flex', justifyContent: "space-around"}}>
                    <button type={"button"} onClick={() => generateReport()} style={{display: display}}
                            className={"btn btn-primary save-info"}>
                        {t('hcpLeumitPatientRequests.generateReport')}
                    </button>

                    <button type={"button"} onClick={() => closeSideBar()} style={{display: display}}
                            className={"btn btn-primary save-info"}>
                        {t('admin.hcp.form.close')}
                    </button>
                </div>
            </div>
        </div>
    )


}
export default AdminGenerateReport;



